import Api from '../api/Api';
import resolve from '../util/Configuracao';
import { parse } from 'date-fns';

const statusFatura = {
  SEM_DATA: 'sem_data',
  COM_AUDITORIA_AUTOMATICA: 'com_auditoria_automatica',
  EM_AUDITORIA: 'em_auditoria',
  AGUARDANDO_LIBERACAO: 'aguardando_liberacao',
  CANCELADO: 'cancelado',
  LIBERADO_PARA_PAGAMENTO: 'liberado_para_pagamento',
  PAGAMENTO_EFETUADO: 'pagamento_efetuado',
  ENCERRADO_SEM_PAGAMENTO: 'encerrado_sem_pagamento',
  EM_AVALIACAO_CNU: 'em_avaliacao_cnu',
  AVALIACAO_CNU_FINALIZADA: 'avaliacao_cnu_finalizada'
};
class FaturaApi extends Api {


  async consultarTodasAsFaturasPorPrestadorOuCodigoFatura (seqPrestador, codFatura) {
    try {
      const consultarLotesPorPrestadorOuCodigoFatura = resolve('urlConsultarLotesPorPrestadorOuCodigoFatura') + seqPrestador + '/fatura/' + codFatura;
      const response = await this.fetch(consultarLotesPorPrestadorOuCodigoFatura);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarFaturasPorPrestadorCodigoStatus (seqPrestador, numCarteiraTst = 'vazio', codFatura, numGuiaPrestador = 'vazio', numGuiaOperadora = 'vazio', 
  txtSenhaAutorizacao = 'vazio', codEstado = 99, codLote = 0, numProtocolo = 'vazio', numDemonstrativo = 0, codTipoGuia = 0, codTipoLote = 0, indReapresentacao = 'vazio',
  recebimentoFrom, recebimentoTo) {
    try {
      const consultarLotesPrestadorCodigoStatus = resolve('urlConsultarLotesPorPrestadorOuCodigoFatura') + seqPrestador + '/numCarteiraTst/' + numCarteiraTst + '/fatura/' + codFatura + '/numGuiaPrestador/' + numGuiaPrestador 
      + '/numGuiaOperadora/' + numGuiaOperadora + '/senha/' + txtSenhaAutorizacao + '/estado/' + codEstado + '/lote/' + codLote + '/protocolo/' + numProtocolo + 
      '/demonstrativo/' + numDemonstrativo + '/tipoGuia/' + codTipoGuia + '/tipoLote/' + codTipoLote + '/recurso/' + indReapresentacao
      + '/' + recebimentoFrom + '/' + recebimentoTo;
      const response = await this.fetch(consultarLotesPrestadorCodigoStatus);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarFaturasPorNumGuiaPrestador (numGuiaPrestador) {
    try {
      const urlConsultarFaturasPorNumGuiaPrestador = `${resolve('urlConsultarFaturasPorNumGuiaPrestador')}/${numGuiaPrestador}`;
      const response = await this.fetch(urlConsultarFaturasPorNumGuiaPrestador);

      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarLotesPorEstadoProtocolo (status) {
    try {
      const consultarLotesPorEstadoProtocoloUrl = resolve('urlConsultarLotesPorEstadoProtocolo') + status;
      const response = await this.fetch(consultarLotesPorEstadoProtocoloUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  /**
 * FATURAS SEM DATA
 * **/

  async consultarTodasAsFaturasSemData () {
    let faturas = [];
    let result = await this.consultarLotesPorEstadoProtocolo(statusFatura.SEM_DATA);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProtocolo } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProtocolo }));
    });
    return faturas;
  }

  async salvarDtaRecebimentoProcessoFisicoEmLote (codLoteGuias, data) {
    try {
      const urlSalvarDtaRecebimentoProcessoFisicoEmLote = resolve('urlSalvarDtaRecebimentoProcessoFisicoEmLote') + 'receber_data_faturas/' + parse(data);
      const result = await this.fetch(urlSalvarDtaRecebimentoProcessoFisicoEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  /**
 * FATURAS SEM AUDITORIA MANUALs
 * **/
  async consultarSemAuditoriaManual () {
    let faturas = [];
    const brancoDetalhar = '';
    let result = await this.consultarLotesPorEstadoProtocolo(statusFatura.COM_AUDITORIA_AUTOMATICA);

    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, indReapresentacao, labelNomTipoGuia, dtaRecebimentoProcessoFisico, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, indReapresentacao, labelNomTipoGuia, dtaRecebimentoProcessoFisico, valTotalProcessado, valTotalGlosado, valTotalLiberado, brancoDetalhar }));
    });
    return faturas;
  }

  /**
 * FATURAS EM AUDITORIA MANUAL
 * **/
  async consultarFaturasEmAuditoria () {
    let faturas = [];
    const branco = '';
    let result = await this.consultarLotesPorEstadoProtocolo(statusFatura.EM_AUDITORIA);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAuditadas } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAuditadas, branco }));
    });
    return faturas;
  }

  async desfazerFaturasEmLote (codLoteGuias) {
    try {
      const url = resolve('urlDesfazerFaturasEmLote');
      const result = await this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    }
    catch (error) {
      console.log(error);
    }
  }

  async finalizarFaturasEmLote (codLoteGuias) {
    try {
      const url = resolve('urlFinalizarFaturasEmLote');
      const result = await this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }

  async auditarAutomaticamenteFaturasEmLote (codLoteGuias) {
    try {
      const url = resolve('urlAuditarAutomaticamenteFaturasEmLote');
      const result = await this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }

  async auditarFaturasEmLote (codLoteGuias) {
    try {
      const url = resolve('urlAuditarFaturasEmLote');
      const result = await this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }

  /**
* FATURAS AGUARDANDO LIBERACAO
* **/
  async consultarTodasAsFaturasAguardandoLiberacao () {
    let faturas = [];
    const branco = '';
    let result = await this.consultarLotesPorEstadoProtocolo(statusFatura.AGUARDANDO_LIBERACAO);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, branco }));
    });
    return faturas;
  }

  async liberarFaturasEmLote (codLoteGuias) {
    try {
      const urlLiberarFaturasEmLote = resolve('urlLiberarFaturasEmLote');
      const result = await this.fetch(urlLiberarFaturasEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    }
    catch (error) {
      console.log(error);
    }
  }

  async negarAuditoriaEmLote (codLoteGuias) {
    try {
      const urlNegarAuditoriaEmLote = resolve('urlNegarAuditoriaEmLote');
      const result = await this.fetch(urlNegarAuditoriaEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }

  /**
  * FATURAS LIBERADAS PARA PAGAMENTO
  * **/
  async consultarTodasAsFaturasLiberadasParaPagamento () {
    let faturas = [];
    const branco = '';
    let result = await this.consultarLotesPorEstadoProtocolo(statusFatura.LIBERADO_PARA_PAGAMENTO);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, branco }));
    });
    return faturas;
  }
  /**
  * FATURAS EM AVALIAÇÃO CNU
  * **/
  async consultarFaturasEmAvaliacaoCNU () {
    let faturas = [];
    const branco = '';
    let result = await this.consultarLotesPorEstadoProtocolo(statusFatura.EM_AVALIACAO_CNU);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAvaliadasCNU, indPossuiGlosaRejeitadaCnu } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, qtdeGuiasJaAvaliadasCNU, indPossuiGlosaRejeitadaCnu, branco }));
    });
    return faturas;
  }

  async finalizarAvaliacaoFaturasCNU (codLoteGuias) {
    try {
      const url = resolve('urlFinalizarAvaliacaoFaturasCNU');
      const result = await this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }
  async devolverFaturasTstEmLote (codLoteGuias) {
    try {
      const url = resolve('urlDevolverFaturasTstEmLote');
      const result = await this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }
  /**
  * FATURAS AVALIAÇÃO CNU FINALIZADA
  * **/
  async consultarFaturasAvaliacaoCNUFinalizada () {
    let faturas = [];
    const branco = '';
    let result = await this.consultarLotesPorEstadoProtocolo(statusFatura.AVALIACAO_CNU_FINALIZADA);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado } = res;
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, branco }));
    });
    return faturas;
  }
  async enviarFaturasCnuEmLote (codLoteGuias) {
    try {
      const url = resolve('urlEnviarFaturasCnuEmLote');
      const result = await this.fetch(url, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }

  /**
  * FATURAS RECEBIDAS
  * **/

  async consultarTodasAsFaturasPorPrestadorOuCodigoFaturaApi (seqPrestador, codFatura) {
    let faturas = [];
    var bolRelatorioGlosa = '';
    var tipoMenu = '';
    let result = await this.consultarTodasAsFaturasPorPrestadorOuCodigoFatura(seqPrestador, codFatura);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, dtaRecebimentoProtocolo, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, situacao, indCancelado, dtaRecebimentoProcessoFisico, motivoCancelamento } = res;
      bolRelatorioGlosa = valTotalGlosado > 0;
      if (indCancelado === 'S' && bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR_E_GLOSA';
      }
      if (indCancelado !== 'S' && bolRelatorioGlosa) {
        tipoMenu = 'GLOSA';
      }
      if (indCancelado === 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR';
      }
      if (indCancelado !== 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'SEM_MENU';
      }
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, dtaRecebimentoProtocolo, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, situacao, tipoMenu, indCancelado, dtaRecebimentoProcessoFisico, motivoCancelamento }));
    });
    return faturas;
  }

  async consultarFaturasPorNumGuiaPrestadorApi (numGuiaPrestador) {
    // let faturas = [];
    // let result =
    // result.map(res => {
    //   const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, situacao, indCancelado, motivoCancelamento, dtaRecebimentoProtocolo } = res;
    //   faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, dtaRecebimentoProtocolo, situacao, tipoMenu, brancoDetalhar, indCancelado, motivoCancelamento }));
    // });
    // return faturas || [];
    let faturas = [];
    const brancoDetalhar = '';
    var bolRelatorioGlosa = '';
    var tipoMenu = '';
    let result = await this.consultarFaturasPorNumGuiaPrestador(numGuiaPrestador);
    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, situacao, indCancelado, motivoCancelamento, dtaRecebimentoProtocolo } = res;
      bolRelatorioGlosa = valTotalGlosado > 0;
      if (indCancelado === 'S' && bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR_E_GLOSA';
      }
      if (indCancelado !== 'S' && bolRelatorioGlosa) {
        tipoMenu = 'GLOSA';
      }
      if (indCancelado === 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR';
      }
      if (indCancelado !== 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'SEM_MENU';
      }
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, dtaRecebimentoProtocolo, situacao, tipoMenu, brancoDetalhar, indCancelado, motivoCancelamento }));
    });
    return faturas || [];
  }
  
  async consultarLotesRecursoPorPrestadorCodigoStatus (seqPrestador, numCarteiraTst = 'vazio', codFatura, numGuiaPrestador = 'vazio', 
  numGuiaOperadora = 'vazio', txtSenhaAutorizacao = 'vazio', codEstado, codLote, numProtocolo = 'vazio',
  numDemonstrativo, codTipoGuia, codTipoLote, indReapresentacao = 'vazio') {

    let lotes = [];
    const branco = '';
    let tipoBotaoCancelamento = '';

    let result = await this.consultarFaturasPorPrestadorCodigoStatus(seqPrestador, numCarteiraTst || 'vazio', codFatura, numGuiaPrestador || 'vazio', 
    numGuiaOperadora || 'vazio', txtSenhaAutorizacao || 'vazio', codEstado, codLote, numProtocolo || 'vazio',
    numDemonstrativo, codTipoGuia, codTipoLote, indReapresentacao || 'vazio', parse(new Date(0)), parse(new Date()));

    result.map(res => {
      const { codLoteGuia, codTipoGuia, cpfCnpjPrestador, dtaRecebimentoProcessoFisico, dtaRecebimentoProtocolo, indCancelado, indPossuiGlosaRejeitadaCnu, indReapresentacao, labelNomTipoGuia, motivoCancelamento, nomPrestador, nomTipoGuia, numLotePrestador, numProtocolo, qtdeGuias, qtdeGuiasJaAuditadas, qtdeGuiasJaAvaliadasCNU, situacao, txtNumeroFatura, valTotalGlosado, valTotalLiberado, valTotalProcessado, numDemonstrativoPag, numDemonstrativoPagRecorrido, dtaFimRecGlosa, indLoteRecursoAuditadoPapel, historicoEstados, numProtocoloRecorrido } = res;

      if (indCancelado === 'S') {
        tipoBotaoCancelamento = 'DESFAZER';
      } else {
        tipoBotaoCancelamento = 'CANCELAR';
      }

      lotes.push(Object.values({ codLoteGuia, numLotePrestador, txtNumeroFatura, nomTipoGuia, cpfCnpjPrestador, nomPrestador, dtaRecebimentoProtocolo, valTotalProcessado, valTotalGlosado, situacao, indCancelado, motivoCancelamento, numProtocolo, tipoBotaoCancelamento, branco, numDemonstrativoPag, valTotalLiberado, numDemonstrativoPagRecorrido, dtaFimRecGlosa, indLoteRecursoAuditadoPapel, historicoEstados, numProtocoloRecorrido, codTipoGuia }));
    });
    return lotes;
  }

  async consultarFaturasPorPrestadorCodigoStatusApi (seqPrestador, numCarteiraTst = 'vazio', codFatura, numGuiaPrestador = 'vazio', 
  numGuiaOperadora = 'vazio', txtSenhaAutorizacao = 'vazio', codEstado, codLote, numProtocolo = 'vazio',
  numDemonstrativo, codTipoGuia, codTipoLote, indReapresentacao = 'vazio', recebimentoFrom, recebimentoTo) {
    let faturas = [];
    const brancoDetalhar = '';
    var bolRelatorioGlosa = '';
    var tipoMenu = '';
    let result = await this.consultarFaturasPorPrestadorCodigoStatus(seqPrestador, numCarteiraTst || 'vazio', codFatura, numGuiaPrestador || 'vazio', 
    numGuiaOperadora || 'vazio', txtSenhaAutorizacao || 'vazio', codEstado, codLote, numProtocolo || 'vazio',
    numDemonstrativo, codTipoGuia, codTipoLote, indReapresentacao || 'vazio', recebimentoFrom, recebimentoTo);

    result.map(res => {
      const { codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, situacao, indCancelado, motivoCancelamento, dtaRecebimentoProtocolo, cpfCnpjPrestador, numLotePrestador } = res;
      bolRelatorioGlosa = valTotalGlosado > 0;
      if (indCancelado === 'S' && bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR_E_GLOSA';
      }
      if (indCancelado !== 'S' && bolRelatorioGlosa) {
        tipoMenu = 'GLOSA';
      }
      if (indCancelado === 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'EXCLUIR';
      }
      if (indCancelado !== 'S' && !bolRelatorioGlosa) {
        tipoMenu = 'SEM_MENU';
      }
      faturas.push(Object.values({ codLoteGuia, qtdeGuias, txtNumeroFatura, nomPrestador, codTipoGuia, labelNomTipoGuia, indReapresentacao, valTotalProcessado, valTotalGlosado, valTotalLiberado, dtaRecebimentoProcessoFisico, dtaRecebimentoProtocolo, situacao, numLotePrestador, tipoMenu, brancoDetalhar, indCancelado, motivoCancelamento, cpfCnpjPrestador }));
    });
    return faturas;
  }

  /**
* LOTES
* **/

  async consultarLote (codLote) {
    try {
      const urlConsultarLote = `${resolve('urlConsultarLote')}/${codLote}`;
      const result = await this.fetch(urlConsultarLote);
      return result;
    } catch (error) { console.log(error); }
  }

  async cancelarFaturasEmLote (codLoteGuias, motivo) {
    try {
      const urlCancelarFaturasEmLote = resolve('urlCancelarFaturasEmLote') + motivo;
      const result = await this.fetch(urlCancelarFaturasEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }

  async excluirFaturasEmLote (codLoteGuias, cpfCnpj) {
    try {
      const urlExcluirFaturasEmLote = resolve('urlExcluirFaturasEmLote') + cpfCnpj;
      const result = await this.fetch(urlExcluirFaturasEmLote, 'POST', codLoteGuias, { 'content-type': 'application/json' });
      return result;
    } catch (error) { console.log(error); }
  }
  async desfazerCancelamentoLote (codLote) {
    try {
      const urlDesfazerCancelamentoLote = resolve('urlDesfazerCancelamentoLote') + codLote + '/desfazer_cancelamento';
      const response = await this.fetch(urlDesfazerCancelamentoLote, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCodigoENumeroFaturas () {
    try {
      const urlCodigoENumeroFaturas = resolve('urlCodigoENumeroFaturas');
      const response = await this.fetch(urlCodigoENumeroFaturas);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarCodigoENumeroLotes () {
    try {
      const urlCodigoENumeroLotes = resolve('urlCodigoENumeroLotes');
      const response = await this.fetch(urlCodigoENumeroLotes);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCodigoENumeroLotesRecurso () {
    try {
      const urlCodigoENumeroLotesRecurso = resolve('urlCodigoENumeroLotesRecurso');
      const response = await this.fetch(urlCodigoENumeroLotesRecurso);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }  
  async consultarFaturasCandidatas (seqPrestador, tipoDemonstrativo, lotesDeRecurso, codFaturasSelecionadas) {
    let faturas = [];
    let brancoAcoes = '';
    const urlFaturasCandidatas = resolve('urlFaturasCandidatas') + seqPrestador + '/' + tipoDemonstrativo + '/' + lotesDeRecurso; 
    const { data } = await this.fetch(urlFaturasCandidatas, 'post', codFaturasSelecionadas);
    data.map(res => {
      const { codFatura, numeroFatura, numLote, dtaRecebimento, numProtocolo, valorProcessado, valorLiberado, valorGlosado, valorLiberadoDependenteEspecial, indReapresentacao } = res;
      faturas.push(Object.values({ codFatura, numeroFatura, numLote, dtaRecebimento, numProtocolo, valorProcessado, valorLiberado, valorGlosado, valorLiberadoDependenteEspecial, indReapresentacao, brancoAcoes }));
    });
    return faturas;
  }
  async incluirLoteRecurso (lote) {
    try {
      const urlIncluirLoteRecurso = resolve('urlIncluirLoteRecurso');
      const response = await this.fetch(urlIncluirLoteRecurso, 'post', lote);
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
  async envioFaturamento (codLote, numLotePrestador) {
    try {
      const urlEnviarLoteRecursoFaturamento = resolve('urlEnviarLoteRecursoFaturamento') + codLote + '/' + numLotePrestador;
      const response = await this.fetch(urlEnviarLoteRecursoFaturamento, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }  
}

export default FaturaApi;
